import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import type { CommentsSummaryResponse, SocialCommentPlatformFilter } from "@multi-chat/shared";
import { AppNotice } from "../../../components/common/AppNotice.js";
import { Button } from "../../../components/ui/button/index.js";

export function CommentsReconnectBanner({
  permissions,
  platformFilter,
}: {
  permissions: CommentsSummaryResponse["permissions"];
  /** When set, only show reconnect for that platform (hides Facebook noise on Instagram-only). */
  platformFilter?: SocialCommentPlatformFilter;
}): React.JSX.Element | null {
  const { t } = useTranslation();
  const showInstagram =
    permissions.instagramNeedsReconnect &&
    (platformFilter == null || platformFilter === "INSTAGRAM");
  const showFacebook =
    permissions.facebookNeedsReconnect &&
    (platformFilter == null || platformFilter === "FACEBOOK");

  if (!showInstagram && !showFacebook) {
    return null;
  }

  let message: string;
  if (showInstagram && showFacebook) {
    message = t("inbox.comments.reconnect.both");
  } else if (showInstagram) {
    message = t("inbox.comments.reconnect.instagram");
  } else {
    message = t("inbox.comments.reconnect.facebook");
  }

  return (
    <div className="mx-2 mb-1.5" data-testid="comments-reconnect-banner">
      <AppNotice
        severity="warning"
        title={t("inbox.comments.reconnect.title")}
        description={message}
        action={
          <Button variant="outline" size="sm" asChild>
            <Link to="/channels">{t("inbox.comments.reconnect.action")}</Link>
          </Button>
        }
        className="py-2"
      />
    </div>
  );
}
